module.exports = __webpack_public_path__ + "assets/img/dayu_index_code.e71c4917.png";